<template src="./ErrorMessage.html">
</template>
<script>
export default {
  name: "error-message",
  props: {
    error: {
      type: Error | Object | String | null,
    },
  },
  data() {
    return {
      variant: 'danger',
      isJsonBody: false,
    }
  },
  computed: {
    errorTitle: function() {
      const { error } = this;
      if (!error) return '';

      const {
        response,
      } = error;
      return (response.data && response.data.title && (response.data.detail || response.data.errors)) ? response.data.title : this.$t("AnErrorOccurred");
    },
    errorDetail: function() {
      var response = this.error && this.error.response;
      return (response && response.data && response.data.detail) || '';
    },
    errorMessage: function() {
      var error = this.error;
      if (!error) return '';

      var response = error.response || {};
      var data = response.data || {};
      var errors = data.errors || {};

      var validationErrors = Object.keys(errors)
        .reduce(function(allErrors, key) {
          return allErrors.concat(errors[key]);
        }, [])
        .filter(function(value) {
          return typeof value === 'string' && value.trim();
        })
        .map(function(value) {
          return value.trim().replace(/\.+$/, '') + '.';
        });

      if (validationErrors.length) {
        return validationErrors;
      }

      return data.detail
        || data.title
        || data.error
        || response.statusText
        || error.message
        || String(error);
    },
    traceId: function() {
      const { error } = this;
      if (!error) return '';

      const {
        response,
      } = error;
      return (response.data && response.data.traceId);
    },
    shouldShowRedirectUrl: function() {
      const { error } = this;
      if (!error) return false;

      const {
        response,
      } = error;
      if (response.data && response.data.status === 307 && response.data.type === "BenefitSummariesException") {
        this.variant = 'info';
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    isLocalHost(){
      return window.location.hostname === 'localhost';
    },
  },
  updated() {
    if (
      this.error
      && this.error.response.data
      && this.error.response.data.type !== "BenefitPointSessionExpired"
      && this.error.response.data.type !== "BenefitPointLoginException"
    ) {
      this.$refs['api-error-container'].show();
      if (this.isLocalHost()) {
        console.log('Error begins next line:')
        console.log(this.error);
        console.log('Error response begins next line:')
        console.log(this.error.response);

          // if(this.error.response.status === 400) {
          //   this.variant = 'danger'
          // }

      }
    } else {
      this.$refs['api-error-container'].hide();
    }
  },
}
</script>
